import(/* webpackMode: "eager" */ "/opt/workspace/dapp/src/pageComponents/Home/HomeMain.tsx")